/* tslint:disable */
/* eslint-disable */
/**
 * Bonds API
 * Microservice backend for bond management
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
/**
 * 
 * @export
 * @interface CreatePayment
 */
export interface CreatePayment {
    /**
     * 
     * @type {number}
     * @memberof CreatePayment
     */
    readonly id: number;
    /**
     * 
     * @type {Date}
     * @memberof CreatePayment
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreatePayment
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreatePayment
     */
    readonly deleted: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePayment
     */
    readonly deletedByCascade: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePayment
     */
    transactionId: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePayment
     */
    sourceAccount?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePayment
     */
    sourceAccountName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePayment
     */
    targetAccount?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePayment
     */
    amount: string;
    /**
     * 
     * @type {Date}
     * @memberof CreatePayment
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof CreatePayment
     */
    specificSymbol?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePayment
     */
    variableSymbol?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePayment
     */
    messageForRecipient?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreatePayment
     */
    data?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof CreatePayment
     */
    createdManually?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreatePayment
     */
    order?: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePayment
     */
    returnObj?: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePayment
     */
    company: number;
}

/**
 * Check if a given object implements the CreatePayment interface.
 */
export function instanceOfCreatePayment(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('createdAt' in value)) return false;
    if (!('updatedAt' in value)) return false;
    if (!('deleted' in value)) return false;
    if (!('deletedByCascade' in value)) return false;
    if (!('transactionId' in value)) return false;
    if (!('amount' in value)) return false;
    if (!('company' in value)) return false;
    return true;
}

export function CreatePaymentFromJSON(json: any): CreatePayment {
    return CreatePaymentFromJSONTyped(json, false);
}

export function CreatePaymentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePayment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (dayjs(json['created_at']).toDate()),
        'updatedAt': (dayjs(json['updated_at']).toDate()),
        'deleted': (json['deleted'] == null ? null : dayjs(json['deleted']).toDate()),
        'deletedByCascade': json['deleted_by_cascade'],
        'transactionId': json['transaction_id'],
        'sourceAccount': json['source_account'] == null ? undefined : json['source_account'],
        'sourceAccountName': json['source_account_name'] == null ? undefined : json['source_account_name'],
        'targetAccount': json['target_account'] == null ? undefined : json['target_account'],
        'amount': json['amount'],
        'date': json['date'] == null ? undefined : (dayjs.tz(json['date'], 'YYYY-MM-DD', dayjs.tz.guess()).toDate()),
        'specificSymbol': json['specific_symbol'] == null ? undefined : json['specific_symbol'],
        'variableSymbol': json['variable_symbol'] == null ? undefined : json['variable_symbol'],
        'messageForRecipient': json['message_for_recipient'] == null ? undefined : json['message_for_recipient'],
        'data': json['data'] == null ? undefined : json['data'],
        'createdManually': json['created_manually'] == null ? undefined : json['created_manually'],
        'order': json['order'] == null ? undefined : json['order'],
        'returnObj': json['return_obj'] == null ? undefined : json['return_obj'],
        'company': json['company'],
    };
}

export function CreatePaymentToJSON(value?: CreatePayment | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'transaction_id': value['transactionId'],
        'source_account': value['sourceAccount'],
        'source_account_name': value['sourceAccountName'],
        'target_account': value['targetAccount'],
        'amount': value['amount'],
        'date': value['date'] == null ? undefined : (dayjs(value['date'] as any).format('YYYY-MM-DD')),
        'specific_symbol': value['specificSymbol'],
        'variable_symbol': value['variableSymbol'],
        'message_for_recipient': value['messageForRecipient'],
        'data': value['data'],
        'created_manually': value['createdManually'],
        'order': value['order'],
        'return_obj': value['returnObj'],
        'company': value['company'],
    };
}

